import { gql } from '@parkchirp/api-client';

export const GET_INVOICE_LINE_ITEMS = gql`
    query getInvoiceLineItems(
        $invoiceId: String!
    ) {
        getInvoiceLineItems(invoiceId: $invoiceId) {
            id
            parker {
                id
                first_name
                last_name          
                selected_end_date
                selected_start_date
            }
            sublot {
                name
                id
            }
            fee {
                type
                price
                tax1
                tax2
                tax3
                tax4
                name
            }
            rate {
                name
            }
            amount
            serviceDateEnd
            serviceDateStart
            balance
            dailyReport {
                id
                readableId
            }
        }
    }
`;
